// 2xx Success Status Codes
export const OK = 200
export const CREATED = 201
export const ACCEPTED = 202
export const NO_CONTENT = 204

// 3xx Redirection Status Codes
export const MOVED_PERMANENTLY = 301
export const FOUND = 302
export const NOT_MODIFIED = 304
export const TEMPORARY_REDIRECT = 307
export const PERMANENT_REDIRECT = 308

// 4xx Client Error Status Codes
export const BAD_REQUEST = 400
export const UNAUTHORIZED = 401
export const PAYMENT_REQUIRED = 402
export const FORBIDDEN = 403
export const NOT_FOUND = 404
export const METHOD_NOT_ALLOWED = 405
export const NOT_ACCEPTABLE = 406
export const REQUEST_TIMEOUT = 408
export const CONFLICT = 409
export const GONE = 410
export const LENGTH_REQUIRED = 411
export const PAYLOAD_TOO_LARGE = 413
export const UNSUPPORTED_MEDIA_TYPE = 415
export const UNPROCESSABLE_ENTITY = 422
export const TOO_MANY_REQUESTS = 429

// 5xx Server Error Status Codes
export const INTERNAL_SERVER_ERROR = 500
export const NOT_IMPLEMENTED = 501
export const BAD_GATEWAY = 502
export const SERVICE_UNAVAILABLE = 503
export const GATEWAY_TIMEOUT = 504
